import { requisitarJson } from '../../../shared/api/http';

/** Se o tablet mostra o ranking para a turma (`visibilidade_turma.ranking`, `AP5`). */
export interface RankingDaTurma {
    turma_id: string;
    nome: string | null;
    ranking: boolean;
    /** Só na alteração: o jogo avisou os tablets da turma. `false` = gravou, mas o aviso não saiu. */
    tablets_avisados?: boolean | null;
}

/** Só as turmas ativas; turma ausente está com o ranking travado. */
export function listarRankings(): Promise<RankingDaTurma[]> {
    return requisitarJson('/api/v1/ranking/turmas');
}

export function alterarRanking(turmaId: string, ranking: boolean, csrfToken: string): Promise<RankingDaTurma> {
    return requisitarJson(`/api/v1/ranking/turmas/${encodeURIComponent(turmaId)}`, {
        method: 'PUT',
        csrfToken,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ranking }),
    });
}
